// Załącznik 7 ENERGA — ewidencja zawierania zgód / tytułów prawnych.

// Formy zgody 1:1 z listą rozwijaną oryginalnego pliku ENERGA (ukryta lista C258:C265).
// Wartości muszą zgadzać się z backendowym Z7ConsentForm.
export const Z7_CONSENT_FORMS: { value: string; label: string }[] = [
  { value: "sluzebnosc_odplatna_an", label: "Służebność przesyłu odpłatna — AN dostarcza projektant" },
  { value: "sluzebnosc_odplatna_eop", label: "Służebność przesyłu odpłatna — AN umawia EOP" },
  { value: "sluzebnosc_nieodplatna_an", label: "Służebność przesyłu nieodpłatna — AN dostarcza projektant" },
  { value: "sluzebnosc_nieodplatna_eop", label: "Służebność przesyłu nieodpłatna — AN umawia EOP" },
  { value: "oswiadczenie_odplatne", label: "Oświadczenie woli odpłatne" },
  { value: "oswiadczenie_nieodplatne", label: "Oświadczenie woli nieodpłatne" },
  { value: "decyzja_drogowa", label: "Decyzja drogowa" },
  { value: "inne", label: "Inne" },
];

export type Z7Section = "projektowane" | "istniejace";
export type Z7Source = "dxf" | "ai" | "manual";

export interface Z7Column {
  code: string;
  label: string;
  section: Z7Section;
  group: string;
  unit: "mb" | "szt" | "m2";
  rate: string;
  order: number;
}

export interface Z7CellVariant {
  value: string | null;
  needs_clarification: boolean;
  note: string;
}

export interface Z7Cell extends Partial<Z7CellVariant> {
  source?: Z7Source;
  all: Partial<Record<Z7Source, Z7CellVariant>>;
}

export interface Z7Valuation {
  items: { column: string; label: string; formula: string; amount: string }[];
  total: string;
  unrated_columns: string[];
}

export interface Z7RowData {
  id: string;
  parcel: {
    id: string; teryt: string; short_number: string; obreb: string; commune: string;
    street_and_number: string; area_m2: number | null; kw_number: string; land_use: string;
  };
  owner: { id: string; full_name: string; address: string; phone: string; share: string } | null;
  property_kind: string;
  consent_form: { value: string; source: "manual" | "basis" | "missing"; locked: boolean };
  final_amount: { value: string | null; source: "row" | "access_title" | "missing" };
  notary_deed: string;
  notes: string;
  include_qty: boolean;
  cells: Record<string, Z7Cell>;
  valuation: Z7Valuation;
}

export interface Z7Overview {
  rows: Z7RowData[];
  columns: Z7Column[];
  missing: { consent_form: number; final_amount: number; owner: number; clarifications: number };
  valuation_total: string;
  rates_missing: number;
  consent_forms: { value: string; label: string }[];
  template_available: boolean;
  pt_files: { id: string; name: string; description: string }[];
  can_mutate: boolean;
  can_edit_rates: boolean;
}

export interface Z7GenerationInfo {
  id: string;
  format: string;
  doc_number: string;
  created_at: string;
  generated_by: string | null;
  totals: Record<string, unknown>;
  file: { id: string; url?: string; original_filename?: string; name?: string };
}
